/* eslint-disable max-lines-per-function */
import './Global.scss';
import 'extensions/fasten-header';
import TransfigureNavigation from 'extensions/transfigure-navigation';
import ContinueShopping from 'extensions/continue-shopping';
import {PageManager} from '@mvps-genesis/bootstrap';
import {GlobalMessageContainer} from 'extensions/messages';
import MiniBasket from 'extensions/mini-basket';
import {initCarousels} from 'extensions/carousel';
import dynamicFormElementAttributes from 'extensions/dynamic-form-element-attributes';

export default class Global extends PageManager {

	constructor (pageContext) {

		super(pageContext);

		this.initSearchPreview();

		/**
		 * Create global message container
		 */
		new GlobalMessageContainer({container: '#js-messages'});

		/**
		 * Initialize the Mini-Basket extension
		 */
		new MiniBasket();

		/**
		 * Initialize the Drop-Down Navigation extension
		 */
		new TransfigureNavigation({
			mainMenuCloseButtons: '.js-close-main-menu',
			mainMenuOpenButtons: '.js-open-main-menu',
			menu: '.x-transfigure-navigation',
			menuLink: '.x-transfigure-navigation__link',
			parentMenuItems: '.js-has-child-menu',
			showPreviousMenuButtons: '.js-show-previous-menu'
		});

		/**
		 * Initialize carousels
		 */
		initCarousels();

		this.initializeHTMLFormValidator();

		/**
		 * Initialize the Dynamic Form-Element Attributes
		 */
		dynamicFormElementAttributes();

		this.initMiniModal();
		this.initLazyload();
		this.initGTM();
		this.initSimpleCaptcha();

	}

	onReady () {

		/**
		 * Toggle the `is-open` state of the global account box.
		 */
		(function () {
			var trigger = document.querySelector('[data-hook="show-related"]');

			if (trigger) {
				var relatedTarget = document.querySelector('[data-hook="' + trigger.getAttribute('data-target') + '"]');

				trigger.addEventListener('click', function (event) {
					event.preventDefault();
					relatedTarget.classList.toggle('is-open');
				}, false);

				document.addEventListener('mousedown', function (event) {
					if (relatedTarget.classList.contains('is-open')) {
						if (!relatedTarget.contains(event.target) && event.target !== trigger) {
							relatedTarget.classList.toggle('is-open');
							event.preventDefault();
						}
					}
				}, false);

				window.addEventListener('keydown', function (event) {
					if (event.defaultPrevented) {
						return;
					}

					switch (event.key) {
					case 'Escape':
						if (relatedTarget.classList.contains('is-open')) {
							relatedTarget.classList.toggle('is-open');
						}
						break;
					default:
						return;
					}

					event.preventDefault();
				}, true);
			}
		}());

		/**
		 * Initialize continue shopping link
		 */
		(() => {
			const continueShoppingLinks = document.getElementsByClassName('js-continue-shopping');
			const continueShoppingOptions = continueShoppingLinks && continueShoppingLinks.length > 0 ? {links: continueShoppingLinks} : {};

			new ContinueShopping(continueShoppingOptions);
		})();

		this.triggerPrint();
		this.initFacets();

	}

	async initSearchPreview () {
		await import('extensions/search-preview');
	}

	async initializeHTMLFormValidator () {

		/**
		 * Initialize Inline Form Validations
		 */

		const forms = document.getElementsByClassName('js-form-validator');

		if (forms.length === 0) {
			return;
		}

		const {HTMLFormValidator} = await import('extensions/form-validation');

		for (const form of forms) {
			form.HTMLFormValidator = new HTMLFormValidator({
				formElement: form,
				wrapperSelector: '.c-form-list__item'
			});
		}
	}

	async initLazyload () {
		// Elements
		const lazyLoadElements = document.getElementsByClassName('lazyload');

		if (lazyLoadElements.length === 0) {
			return;
		}

		// Module
		await import('lazysizes/plugins/unveilhooks/ls.unveilhooks');
		await import('lazysizes/plugins/bgset/ls.bgset');
		await import('lazysizes/plugins/custommedia/ls.custommedia');
		await import('lazysizes');
	}

	async initMiniModal () {

		/**
		 * Mini Modal
		 */
		// Elements
		const miniModalElements = Array.from(document.querySelectorAll('[data-mini-modal]'));

		if (miniModalElements.length === 0) {
			return;
		}

		// Module
		const {default: minimodal} = await import('extensions/minimodal');

		// Initiate the modal for each element
		miniModalElements.forEach(element => {
			minimodal(element).init();
		});
	}

	triggerPrint () {

		/**
		 *  Launch Printer Dialog
		 */
		const printTriggers = document.getElementsByClassName('js-trigger-print');

		if (printTriggers.length) {
			for (const element of printTriggers) {
				element.addEventListener('click', function (e) {
					e.preventDefault();
					window.print();
				}, false);
			}
		}

	}

	async initFacets () {

		/**
		 * Initialize Facets Functionality
		 */
		const faceting = document.getElementById('js-faceting');

		if (faceting) {
			const {default: Facets} = await import('custom-extensions/facets/Facets');
			new Facets();
		}
	}

	async initGTM () {

		const {default: GTM} = await import('extensions/gtm');

		const gtm = new GTM(this.pageContext);
		gtm.init();

		// Listen for Print Events
		window.addEventListener('beforeprint', () => {
			gtm.sendEvent({
				action: 'Click',
				category: 'Print',
				label: document.title,
				noninteractionHit: false
			});
		});
	}

	async initSimpleCaptcha () {
		const forms = document.getElementsByClassName('js-form-captcha');

		if (forms.length === 0) {
			return;
		}

		const {default: SimpleCaptcha} = await import('custom-extensions/simple-captcha');

		for (const form of forms) {
			new SimpleCaptcha(form);
		}
	}

}
